















import { Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ConstructionStoreGetters } from './store/ConstructionTypes';

export default class App extends Vue {

    @Getter(ConstructionStoreGetters.ConstructionFormIsDirty)
    public readonly constructionFormIsDirty!: boolean;

    public mounted() {
      window.addEventListener('beforeunload', (e) => {
          if (this.constructionFormIsDirty) {
              const confirmationMessage = this.$t('common.unsavedData.message').toString();
              (e || window.event).returnValue = confirmationMessage;
              return confirmationMessage;
          }
          return undefined;
      });
    }
}
